import { redirect } from '@tanstack/react-router';
import { useAuthStore } from '../../stores/auth';

/**
 * 보호 라우트 공용 가드 — beforeLoad에서 호출.
 * 세션 초기화가 끝날 때까지 기다린 뒤, 미로그인 시 로그인 화면으로 보낸다.
 */
export async function requireAuthBeforeLoad(redirectTo: string): Promise<void> {
  const { initializing } = useAuthStore.getState();

  if (initializing) {
    await new Promise<void>((resolve) => {
      const unsub = useAuthStore.subscribe((state) => {
        if (!state.initializing) {
          unsub();
          resolve();
        }
      });
    });
  }

  if (!useAuthStore.getState().session) {
    throw redirect({ to: '/auth/signin', search: { redirect: redirectTo } });
  }
}
